import { render, staticRenderFns } from "./EditGvdPage.modal.vue?vue&type=template&id=6169fd5b"
import script from "./EditGvdPage.modal.vue?vue&type=script&lang=ts"
export * from "./EditGvdPage.modal.vue?vue&type=script&lang=ts"
import style0 from "./EditGvdPage.modal.vue?vue&type=style&index=0&id=6169fd5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports